import { render, staticRenderFns } from "./commit_options_dropdown.vue?vue&type=template&id=f495d59a"
import script from "./commit_options_dropdown.vue?vue&type=script&lang=js"
export * from "./commit_options_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports